import React from 'react';
import { useParams } from 'react-router-dom';
import get from 'lodash/get';

import {
  Button as ChakraButton,
  Icon,
  icons,
  Text,
} from '@tapresearch/ui/components';

import { Buttons } from 'Shared/Button';

import * as SR from '../campaign/SurveyResults.styled';
import * as S from './CampaignResult.styled';

import { FieldingStats } from '../campaign/FieldingStats';
import Link from '../common/Link';
import { SurveyResultsWrapper } from '../campaign/Results';

export default ({ results, campaign }) => {
  const { identifier } = useParams();

  const firstResponse = get(results, 'fielding.first_response');
  const lastResponse = get(results, 'fielding.last_response');
  const completesCount = get(results, 'fielding.completes_count', 0);
  const tapSurveyIdentifier = get(campaign, 'tap_survey.identifier');

  const originalTotal = campaign.original_quotas_total;
  const resultsCsvUrl =
    get(campaign, 'project_export.results_csv_download_url') ||
    `/insights_platform/data/${identifier}.csv`;

  const questionsHash = get(results, 'questions', {});

  return (
    <S.CampaignResult>
      <S.Body>
        <Text
          as="h2"
          fontSize="2xl"
          display="flex"
          justifyContent="space-around"
        >
          {campaign.name}
        </Text>
        <SR.SurveyResults>
          <SR.Header>
            <SR.HeaderLeft>
              <FieldingStats
                originalTotal={originalTotal}
                firstResponse={firstResponse}
                lastResponse={lastResponse}
                campaignStatus={campaign.status}
                completesCount={completesCount}
              />
            </SR.HeaderLeft>
            <SR.HeaderRight>
              {completesCount > 0 && (
                <Link to={resultsCsvUrl} external={true} download>
                  <ChakraButton
                    {...Buttons.PrimarySmall}
                    mr={4}
                    leftIcon={
                      <Icon boxSize={4} icon={icons.fi.DownloadCloud} />
                    }
                  >
                    Responses
                  </ChakraButton>
                </Link>
              )}
            </SR.HeaderRight>
          </SR.Header>
          <SR.Body>
            {completesCount > 0 ? (
              <SurveyResultsWrapper
                tapSurveyIdentifier={tapSurveyIdentifier}
                campaignResultIdentifier={identifier}
                countryId={campaign.country_id}
                languageId={campaign.language_id}
                questionsHash={questionsHash}
              />
            ) : (
              <SR.Panel>
                <Text
                  {...{
                    fontWeight: 'medium',
                    fontSize: 'xl',
                    color: 'gray.400',
                  }}
                  as="h3"
                >
                  No responses gathered yet.
                </Text>
              </SR.Panel>
            )}
          </SR.Body>
        </SR.SurveyResults>
      </S.Body>
    </S.CampaignResult>
  );
};
